import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useDecodeURL = () => {
  const history = useHistory();

  const pathname = window.location.pathname || '';
  const decodedPathname = decodeURIComponent(pathname) || '';

  useLayoutEffect(() => {
    if (decodedPathname !== pathname) {
      history.push({
        pathname: decodedPathname,
      });

      window.location.reload();
    }
  }, []);
};
